export const LEVELS_WITH_ACTIVE_HELP_FEATURES = ['basic', 'beginner'];
